<template>
    <div class="input-group h-100 w-100 product-quantity-handler">
        <button
            class="btn btn-lg btn-outline-primary btn-grey product_quantity_btn_minus"
            type="button"
            @click.prevent="updateQuantity(-1)"
        ></button>
        <input
            type="number"
            class="form-control form-control-lg text-center no-arrows mw-100"
            v-model="quantity"
            @click.prevent=""
            @keyup="updateQuantityInput($event)"
            maxlength="7"
        />
        <button
            class="btn btn-lg btn-outline-primary btn-grey product_quantity_btn_plus"
            type="button"
            @click.prevent="updateQuantity(+1)"
        ></button>
    </div>
</template>

<script setup>
import { useProductQuantityStore } from '~/stores/ProductQuantityStore'

const props = defineProps({
    product: Object,
    init: Boolean
})

const emit = defineEmits(['update-quantity'])
const step = props.product.order_quantity_step || 1
const quantityStore = useProductQuantityStore()
const quantity = ref(quantityStore.quantities[props.product.id] || step);

const adjustQuantity = () => {
    if (step <= 1) return
    if (quantity.value <= step) {
        quantity.value = step
    } else {
        const mod = quantity.value % step
        quantity.value = mod ? quantity.value + (step - mod) : quantity.value
    }
}

const updateQuantityInput = (e) => {
    adjustQuantity()
    emit('update-quantity', quantity.value)
    quantityStore.updateQuantity(props.product.id, quantity.value)
}

const updateQuantity = (plus) => {
    quantity.value += plus * step
    if (quantity.value < step) {
        quantity.value = step
    }
    adjustQuantity()
    emit('update-quantity', quantity.value)
    quantityStore.setQuantity(props.product.id, quantity.value)
}
</script>
